import { toast } from 'sonner';

import { useApiMutation, useApiQuery } from '@/modules/common';

import { ModelDetails, ModelsUploadUrlData, UpdateModelBody } from '../types';
import { useModelAttributes } from './useModelAttributes';

export function useModelDetails(modelId: string) {
  const { data: optionsData } = useModelAttributes();

  const { data: uploadUrlData, refetch: refetchUploadUrl } =
    useApiQuery<ModelsUploadUrlData>(`/models/reupload-url/${modelId}`, {
      queryKey: ['modelDetailsUploadUrl'],
      initialData: null,
    });

  const { isFetching, data } = useApiQuery<ModelDetails>(`/models/${modelId}`, {
    queryKey: ['modelDetails'],
    initialData: null,
  });

  const updateModelMutation = useApiMutation<UpdateModelBody>(
    '/models',
    {
      method: 'PATCH',
    },
    {
      onError: () => {
        toast.error('Uh oh! Something went wrong.');
      },
    }
  );

  return {
    optionsData,
    isFetching,
    uploadUrlData,
    details: data,
    refetchUploadUrl,
    updateModelMutation,
  } as const;
}
